import * as i0 from '@angular/core';
import { InjectionToken, Component, ChangeDetectionStrategy, Inject, Injectable, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoadingBarHttpClientModule } from '@ngx-loading-bar/http-client';
import { MatButtonModule } from '@angular/material/button';
import * as i1$1 from '@angular/material/dialog';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import * as i1 from '@ngx-loading-bar/core';
import { HttpContextToken, HTTP_INTERCEPTORS } from '@angular/common/http';
import { Subject } from 'rxjs';

const FS_PROGRESS_DEFAULT_CONFIG = new InjectionToken('fs-progress.default-config');
const FS_PROGRESS_CONFIG = new InjectionToken('fs-progress.config');

class FsProgressComponent {
    constructor(config) {
        this.config = config;
    }
}
FsProgressComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsProgressComponent, deps: [{ token: FS_PROGRESS_CONFIG }], target: i0.ɵɵFactoryTarget.Component });
FsProgressComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.16", type: FsProgressComponent, selector: "fs-progress", ngImport: i0, template: "<ngx-loading-bar \n  [includeSpinner]=\"false\" \n  [color]=\"config.barColor\" \n  [height]=\"config.barHeight + 'px'\">\n</ngx-loading-bar>", components: [{ type: i1.LoadingBarComponent, selector: "ngx-loading-bar", inputs: ["includeSpinner", "includeBar", "fixed", "value", "color", "height", "diameter"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsProgressComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'fs-progress',
                    templateUrl: 'progress.component.html',
                    changeDetection: ChangeDetectionStrategy.OnPush,
                }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [FS_PROGRESS_CONFIG]
                }] }]; } });

class FsProgressService {
    constructor(dialog, config) {
        this.dialog = dialog;
        this.config = config;
    }
}
FsProgressService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsProgressService, deps: [{ token: i1$1.MatDialog }, { token: FS_PROGRESS_CONFIG }], target: i0.ɵɵFactoryTarget.Injectable });
FsProgressService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsProgressService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsProgressService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1$1.MatDialog }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [FS_PROGRESS_CONFIG]
                }] }]; } });

const FS_PROGRESS_DISABLE = new HttpContextToken(() => false);

class ProgressInterceptor {
    constructor(loader) {
        this.loader = loader;
    }
    intercept(req, next) {
        var _a;
        if ((_a = req.context) === null || _a === void 0 ? void 0 : _a.get(FS_PROGRESS_DISABLE)) {
            return next.handle(req.clone({ headers: req.headers.append('ignoreLoadingBar', '') }));
        }
        return next.handle(req);
    }
}
ProgressInterceptor.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: ProgressInterceptor, deps: [{ token: i1.LoadingBarService }], target: i0.ɵɵFactoryTarget.Injectable });
ProgressInterceptor.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: ProgressInterceptor });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: ProgressInterceptor, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1.LoadingBarService }]; } });

class FsProgressInterceptorModule {
}
FsProgressInterceptorModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsProgressInterceptorModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
FsProgressInterceptorModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsProgressInterceptorModule });
FsProgressInterceptorModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsProgressInterceptorModule, providers: [
        {
            provide: HTTP_INTERCEPTORS,
            useClass: ProgressInterceptor,
            multi: true,
        },
    ] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsProgressInterceptorModule, decorators: [{
            type: NgModule,
            args: [{
                    providers: [
                        {
                            provide: HTTP_INTERCEPTORS,
                            useClass: ProgressInterceptor,
                            multi: true,
                        },
                    ],
                }]
        }] });

class FsProgressModule {
    static forRoot(config) {
        return {
            ngModule: FsProgressModule,
            providers: [
                { provide: FS_PROGRESS_DEFAULT_CONFIG, useValue: config },
                {
                    provide: FS_PROGRESS_CONFIG,
                    useFactory: FsProgressConfigFactory,
                    deps: [FS_PROGRESS_DEFAULT_CONFIG]
                }
            ]
        };
    }
}
FsProgressModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsProgressModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
FsProgressModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsProgressModule, declarations: [FsProgressComponent], imports: [CommonModule,
        FsProgressInterceptorModule,
        LoadingBarHttpClientModule,
        MatDialogModule,
        MatButtonModule,
        MatIconModule,
        MatProgressSpinnerModule], exports: [FsProgressComponent,
        LoadingBarHttpClientModule] });
FsProgressModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsProgressModule, providers: [
        FsProgressService
    ], imports: [[
            CommonModule,
            FsProgressInterceptorModule,
            LoadingBarHttpClientModule,
            MatDialogModule,
            MatButtonModule,
            MatIconModule,
            MatProgressSpinnerModule
        ], LoadingBarHttpClientModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsProgressModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        FsProgressInterceptorModule,
                        LoadingBarHttpClientModule,
                        MatDialogModule,
                        MatButtonModule,
                        MatIconModule,
                        MatProgressSpinnerModule
                    ],
                    exports: [
                        FsProgressComponent,
                        LoadingBarHttpClientModule
                    ],
                    declarations: [
                        FsProgressComponent
                    ],
                    providers: [
                        FsProgressService
                    ],
                }]
        }] });
function FsProgressConfigFactory(config) {
    return Object.assign({ barHeight: 2, barColor: '#efefef', processingDialogMessage: 'Please wait...' }, config);
}

class ProgressDialog {
    constructor() {
        this.completed = false;
        this._processSubject$ = new Subject();
        this._message$ = new Subject();
    }
    setDialogRef(dialogRef) {
        this._dialogRef = dialogRef;
    }
    complete() {
        this._processSubject$.next();
        this._processSubject$.complete();
        this.completed = true;
    }
    get process$() {
        return this._processSubject$.asObservable();
    }
    get message$() {
        return this._message$.asObservable();
    }
    updateMessage(message) {
        this._message$.next(message);
    }
    close() {
        this._dialogRef.close();
    }
}

/**
 * Generated bundle index. Do not edit.
 */

export { FS_PROGRESS_DISABLE, FsProgressComponent, FsProgressModule, FsProgressService, ProgressDialog };
